import dayjs from 'dayjs';
import { formatDate } from './format-date';

export const formatDateDifference = (startDate: string, endDate?: string) => {
  const start = dayjs(startDate).startOf('day');
  const end = endDate ? dayjs(endDate).startOf('day') : dayjs(dayjs().format('YYYY-MM-DD'));
  const diff = end.diff(start, 'day');

  if (diff === 0) {
    return `${formatDate(startDate)} (0)`;
  }

  const sign = diff < 0 ? '+' : '-';
  return `${formatDate(endDate || startDate)} (${sign}${Math.abs(diff)})`;
};
